import axios from 'axios';
import getEnvironmentVariables from "./getEnv";

class axiosApi {
    static get(endpoint, params, withCredentials = false) {
        let AppEnv = getEnvironmentVariables();

        let config = {
            headers: null,
            params: params,
            withCredentials: withCredentials
        };

        let url = AppEnv.gatewayUri + "/" + endpoint;

        if (document.documentMode) {  //Prevent IE from caching the response and not making subsequent requests
            config.headers.Pragma = 'no-cache';
        }
        return this.getEndpoint(url, config);
    }
    static post(endpoint, data, withCredentials = false) {
        let AppEnv = getEnvironmentVariables();

        let config = {
            headers: null,
            withCredentials: withCredentials
        };

        let url = AppEnv.gatewayUri + "/" + endpoint;

        return this.postEndpoint(url, data, config);
    }
    
    static getEndpoint(url, config) {
        return axios.get(url, config).then(response => {
            return response.data;
        }).catch(error => {
            throw error;
        });
    }
    static postEndpoint(url, data, config) {
        return axios.post(url, data, config).then(response => {
            return response.data;
        }).catch(error => {
            throw error;
        });
    }
}

export default axiosApi;  